import { render, staticRenderFns } from "./applicant-stats.vue?vue&type=template&id=bd4bc464&scoped=true"
import script from "./applicant-stats.vue?vue&type=script&lang=js"
export * from "./applicant-stats.vue?vue&type=script&lang=js"
import style0 from "./applicant-stats.vue?vue&type=style&index=0&id=bd4bc464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4bc464",
  null
  
)

export default component.exports